
































































import {
  defineComponent,
  computed,
  useRouter,
  ref,
} from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import CategoryProductFace from "~/modules/catalog/category/components/views/CategoryProductFace.vue";
import { useCategoryPageStore } from "~/modules/catalog/category/stores/categoryPage";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { getUrlPathByCategory } from "~/modules/catalog/category/helpers";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

export default defineComponent({
  name: "NewProduct",
  components: {
    LazyComponent,
    CategoryProductFace,
    ProductLoadItem,
    SkeletonLoader
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter();
    const categoryStore = useCategoryStore();
    const categoryPageStore = useCategoryPageStore();
    const categoryTree = computed(() => categoryStore.categories);
    const totalPages = ref(1);
    const itemsPerPage = ref(16);
    const totalItems = ref(0);
    const productsLength = ref(0);

    const currentPage = computed({
      get: () => categoryPageStore.currentPage,
      set: (value) => categoryPageStore.setCurrentPage(value),
    });

    const handleLoadMore = () => {
      categoryPageStore.setCurrentPage(categoryPageStore.currentPage + 1);
    };

    const goToCateById = async (row) => {
      const url_path = getUrlPathByCategory(row, categoryTree.value);
      if (url_path) {
        router.push(`/${url_path}`);
      }
    };

    const totalProducts = computed(() => {
      return productsLength.value > itemsPerPage.value
        ? productsLength.value
        : itemsPerPage.value;
    });

    return {
      goToCateById,
      currentPage,
      totalPages,
      itemsPerPage,
      totalItems,
      productsLength,
      totalProducts,
      handleLoadMore,
    };
  },
});
